import {selectDateDayJSFormat, selectLang, Translate} from "../../../../../app/store/reducers/main/mainReducer";
import {useSelector} from "react-redux";
import React, {useState} from "react";
import {loadDraftPDFAsync} from "../../../../../app/store/reducers/roaming/roamingInvoiceReducer";
import {downloadFile} from "../../../../../helpers/excel-uploader";
import dayjs from "dayjs";
import {toast} from "react-toastify";
import IconButton from "../../../../common/IconButton";
import {faFilePdf} from "@fortawesome/free-solid-svg-icons";
import {Spinner} from "react-bootstrap";

const RoamingDraftInvoiceDownloadToPdf = ({invoice, ...props}) => {
    const t = Translate;
    const lang = useSelector(selectLang);
    const dateFormat = useSelector(selectDateDayJSFormat);
    const [loading, setLoading] = useState(false);

    const onDownloadToPdf = () => {
        setLoading(true);
        loadDraftPDFAsync(invoice.id)
            .then((response) => {
                setLoading(false);
                downloadFile({
                    content: response,
                    contentType: response.type,
                    fileName: `${invoice.info.number}-${dayjs(invoice.info.date).format(dateFormat)}`,
                });
            })
            .catch(error => {
                setLoading(false);
                toast.error(t(lang, "roaming.invoice.print_failed_error"))
            })
    }

    return (
        <IconButton {...props} icon={faFilePdf}
                    transform="shrink-3"
                    size="sm"
                    variant={'falcon-info'}
                    className="m-1"
                    onClick={onDownloadToPdf}
        >
            <span className="d-none d-sm-inline-block">{t(lang, 'edi.contract_formation.view.download_pdf')}</span>
            {loading && <Spinner className="align-middle ms-2" size="sm" animation="border" role="switch"/>}
        </IconButton>
    );
};

export default RoamingDraftInvoiceDownloadToPdf;
